import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import LoginButton from './LoginButton.jsx';
import Balance from './Balance.jsx';

import {balance as balanceAction} from 'actions/balance/balanceAction';

class Authenticated extends React.Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        balance: PropTypes.any.isRequired,
        domain: PropTypes.string.isRequired,
        balanceAction: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this._handleHelpClick = this._handleHelpClick.bind(this);
    }

    _handleHelpClick(e) {
        e.preventDefault();
        const {domain} = this.props;

        const link = '//members.' + domain + '/messages/incoming';

        window.open(link, 'MyAccount',
            "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
    }

    render() {
        const balance = this.props.balance;
        const login = this.props.user.get('login');
        const resourceId = this.props.user.get('resourceId');
        const accountNum = this.props.user.get('accountNum');
        const balanceAction = this.props.balanceAction;

        return (
            <ul>
                <LoginButton login={login} accountNum={accountNum} />
                <Balance resourceId={resourceId} balance={balance} refreshAction={balanceAction} />
            </ul>
        );
    }
}

const select = function(state, props) {
    return {...props};
};

export default connect(select, {balanceAction})(Authenticated);


// WEBPACK FOOTER //
// ./js/sport-betting/components/header/Authenticated.jsx